import type { ComponentType, SvelteComponent, SvelteComponentTyped } from 'svelte'

export class SharePageDto {
    constructor() {
        this.component = []
        this.props = []
    }
    component: any[]
    props: any[]
    hideHeader?: boolean
    hideFooter?: boolean
    hideWaterMark?: boolean
    waitLoadedEvent?: boolean
}
